exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-red[data-v-215c009c]{\n    border-right: 5px solid #ab0d48;\n}\n", ""]);

// exports
